module.exports = "/_next/static/images/complexTechnologies-9994e82ecdd1823d4c8a2dcf54d4e66b.png";